export default "__VITE_ASSET__Bxr$ikDq__"